/*
 * Copyright (c) 2017 Datarista, Inc.
 */

import { actionTypes as commonActionTypes } from '../actions/common';

const initialState = null;

export default function reducer(state = initialState, action) {
  switch (action.type) {
    // Success
    case commonActionTypes.SUCCESS: {
      const success = {
        text: action.text,
        data: action.data,
      };
      return success;
    }
    // Dismiss Success
    case '@@router/LOCATION_CHANGE':
    case commonActionTypes.DISMISS_SUCCESS: {
      return null;
    }
    default: {
      return state;
    }
  }
}
